const _ = require('lodash');
const framework503Handler = require('swa-status-handlers/framework-503-handler');

const maintenanceCodes = [
    '503312996'
];

const isMaintenanceTrackingCode = function (settings) {
    return _.find(maintenanceCodes, (code) => code === _.get(settings, 'jqXHR.responseJSON.notifications.formErrors["0"].trackingCode'));
};

const shouldCallMaintenanceHandler = function (settings) {
    return (
        // Temporal change until the uimetadata service is updated in all the SPA to allow trigger maintenance mode
        // !_.get(settings, 'options.disableServiceTriggeringMaintenanceMode') &&
        isMaintenanceTrackingCode(settings)
    );
};


module.exports = function (settings) {
    let updatedSettings;

    if (shouldCallMaintenanceHandler(settings)) {
        framework503Handler(settings);
    } else {
        updatedSettings = _.cloneDeep(settings);

        _.set(updatedSettings, 'options.disableServiceTriggeringMaintenanceMode', true);
        framework503Handler(updatedSettings);
    }
};
